"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLayersTwo1 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconLayersTwo1 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7234 3.57571C11.9062 3.54141 12.0938 3.54141 12.2766 3.57571C12.493 3.61632 12.6861 3.71485 12.7794 3.76246C12.789 3.76736 12.7976 3.77172 12.805 3.77543L22.4472 8.59654C22.786 8.76594 23 9.1122 23 9.49097C23 9.86974 22.786 10.216 22.4472 10.3854L12.805 15.2065C12.7976 15.2102 12.789 15.2146 12.7794 15.2195C12.6861 15.2671 12.493 15.3656 12.2766 15.4062C12.0938 15.4405 11.9062 15.4405 11.7234 15.4062C11.507 15.3656 11.3139 15.2671 11.2206 15.2195C11.211 15.2146 11.2024 15.2102 11.195 15.2065L1.55279 10.3854C1.214 10.216 1 9.86974 1 9.49097C1 9.1122 1.214 8.76594 1.55279 8.59654L11.195 3.77543C11.2024 3.77172 11.211 3.76736 11.2206 3.76246C11.3139 3.71485 11.507 3.61632 11.7234 3.57571Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.52769 13.109L1.55279 13.5964C1.214 13.7658 1 14.1121 1 14.4909C1 14.8696 1.214 15.2159 1.55279 15.3853L11.195 20.2064L11.2206 20.2194C11.3139 20.267 11.507 20.3655 11.7234 20.4061C11.9062 20.4404 12.0938 20.4404 12.2766 20.4061C12.493 20.3655 12.6861 20.267 12.7794 20.2194L12.805 20.2064L22.4472 15.3853C22.786 15.2159 23 14.8696 23 14.4909C23 14.1121 22.786 13.7658 22.4472 13.5964L21.4723 13.109L13.6994 16.9954L13.6876 17.0013C13.6388 17.0259 13.5187 17.0861 13.3985 17.1384C13.2382 17.2082 12.9785 17.3095 12.6454 17.372C12.2189 17.452 11.7811 17.452 11.3546 17.372C11.0215 17.3095 10.7618 17.2082 10.6015 17.1384C10.4813 17.0861 10.3612 17.0259 10.3124 17.0014L10.3006 16.9954L2.52769 13.109Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 14.5L11.6422 19.3211C11.7734 19.3867 11.839 19.4195 11.9078 19.4324C11.9687 19.4438 12.0313 19.4438 12.0922 19.4324C12.161 19.4195 12.2266 19.3867 12.3578 19.3211L22 14.5M2 9.5L11.6422 4.67889C11.7734 4.6133 11.839 4.5805 11.9078 4.5676C11.9687 4.55616 12.0313 4.55616 12.0922 4.5676C12.161 4.5805 12.2266 4.6133 12.3578 4.67889L22 9.5L12.3578 14.3211C12.2266 14.3867 12.161 14.4195 12.0922 14.4324C12.0313 14.4438 11.9687 14.4438 11.9078 14.4324C11.839 14.4195 11.7734 14.3867 11.6422 14.3211L2 9.5Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconLayersTwo1 = IconLayersTwo1;
//# sourceMappingURL=IconLayersTwo1.js.map